document.addEventListener("DOMContentLoaded", function () {
  const applianceSelect = document.getElementById("appliance");
  const customWattageGroup = document.getElementById("custom-wattage-group");
  const calculateBtn = document.getElementById("calculate-btn");
  const resultsDiv = document.getElementById("results");

  applianceSelect.addEventListener("change", function () {
    if (this.value === "custom") {
      customWattageGroup.style.display = "block";
    } else {
      customWattageGroup.style.display = "none";
    }
  });

  calculateBtn.addEventListener("click", function () {
    calculateCost();
  });

  // ✅ 修复：绑定到正确的 id "electricity-usage"
  document.getElementById("electricity-usage").addEventListener("keypress", function (e) {
    if (e.key === "Enter") calculateCost();
  });

  document.getElementById("price").addEventListener("keypress", function (e) {
    if (e.key === "Enter") calculateCost();
  });

  document.getElementById("custom-wattage").addEventListener("keypress", function (e) {
    if (e.key === "Enter") calculateCost();
  });

  function calculateCost() {
    let wattage;
    if (applianceSelect.value === "custom") {
      wattage = parseFloat(document.getElementById("custom-wattage").value);
      if (isNaN(wattage) || wattage <= 0) {
        alert("Please enter a valid wattage");
        return;
      }
    } else {
      wattage = parseFloat(applianceSelect.value);
    }

    // ✅ 修复：从 "electricity-usage" 读取，避免与 lighting 区的 select#usage 冲突
    const usageInput = parseFloat(document.getElementById("electricity-usage").value);
    if (isNaN(usageInput) || usageInput < 0) {
      alert("Please enter a valid usage value");
      return;
    }

    const usageUnit = document.getElementById("usage-unit").value;
    let usageHours;
    if (usageUnit === "minutes") {
      usageHours = usageInput / 60;
    } else {
      usageHours = usageInput;
    }

    const price = parseFloat(document.getElementById("price").value);
    if (isNaN(price) || price < 0) {
      alert("Please enter a valid electricity price");
      return;
    }

    const kWhPerDay = (wattage * usageHours) / 1000;
    const costPerHour = (wattage / 1000) * price;
    const costPerDay = kWhPerDay * price;
    const costPerMonth = costPerDay * 30;
    const costPerYear = costPerDay * 365;

    document.getElementById("cost-hour").textContent = "$" + costPerHour.toFixed(2);
    document.getElementById("cost-day").textContent = "$" + costPerDay.toFixed(2);
    document.getElementById("cost-month").textContent = "$" + costPerMonth.toFixed(2);
    document.getElementById("cost-year").textContent = "$" + costPerYear.toFixed(2);
    document.getElementById("kwh-day").textContent = kWhPerDay.toFixed(2);

    resultsDiv.style.display = "block";
  }
});

 
    // ========== 配置项：可根据业务需求自由扩展 ==========
    // 灯具类型配置：名称、功率、光通量
    const LIGHT_TYPES = [
      { name: "100W (15000lm)", power: 100, lumens: 15000 },
      { name: "130W (19500lm)", power: 130, lumens: 19500 },
      { name: "150W (22500lm)", power: 150, lumens: 22500 },
      { name: "200W (30000lm)", power: 200, lumens: 30000 },
      { name: "210W (31500lm)", power: 210, lumens: 31500 },
      { name: "240W (36000lm)", power: 240, lumens: 36000 },
      { name: "300W (45000lm)", power: 300, lumens: 45000 },
      { name: "400W (60000lm)", power: 400, lumens: 60000 },
      { name: "500W (75000lm)", power: 500, lumens: 75000 },
      
    ];

    // 使用场景配置：名称、目标照度
    const USAGE_TYPES = [
      { name: "Warehouse (100-300 lux)", targetLux: 200 },
      { name: "Workshop (300-500 lux)", targetLux: 400 },
      { name: "Industrial (500-750 lux)", targetLux: 600 },
      { name: "Office (500-700 lux)", targetLux: 600 },
      { name: "Factory (500-750 lux)", targetLux: 600 },
      { name: "Retail Stores (500-1000 lux)", targetLux: 750 },
      { name: "Restaurants (300-500 lux)", targetLux: 400 },
      { name: "General Manufacturing (600-800 lux)", targetLux: 700 },
      { name: "Assembly Line (500-750 lux)", targetLux: 600 },
      { name: "Classrooms (300-500 lux)", targetLux: 400 },
      { name: "Laboratories (500-1000 lux)", targetLux: 900 },
      { name: "Hospital Wards (200-300 lux)", targetLux: 200 },
      { name: "Operating Rooms (1000-2000 lux)", targetLux: 1500 },
      { name: "Sidewalks (100-200 lux)", targetLux: 150 },
    ];

    // 照明工程标准系数
    const MAINTENANCE_FACTOR = 0.7; // 维护系数（灰尘、光衰）
    const UTILIZATION_FACTOR = 0.65; // 利用系数（空间反射、灯具效率）
    const LUMEN_EFFICIENCY = 150; // 灯具光效 lm/W，用于功率建议计算
    // ==================================================

    // 初始化下拉选项
    function initSelects() {
      const lightSelect = document.getElementById('lightType');
      const usageSelect = document.getElementById('usageType');
      
      LIGHT_TYPES.forEach(item => {
        const option = document.createElement('option');
        option.value = item.name;
        option.textContent = item.name;
        lightSelect.appendChild(option);
      });

      USAGE_TYPES.forEach(item => {
        const option = document.createElement('option');
        option.value = item.name;
        option.textContent = item.name;
        usageSelect.appendChild(option);
      });
    }

    /**
     * 计算满足照度要求的理论最小灯具数
     */
    function calcMinFixtureCount(areaSqm, targetLux, fixtureLumens) {
      const totalLumensNeeded = (targetLux * areaSqm * MAINTENANCE_FACTOR) / UTILIZATION_FACTOR;
      return Math.ceil(totalLumensNeeded / fixtureLumens);
    }

    /**
     * 计算最优网格行列：匹配房间长宽比，总数≥理论最小数量
     */
    function getOptimalGrid(minCount, length, width) {
      const targetRatio = length / width; // 房间长宽比
      let bestRows = 1;
      let bestCols = minCount;
      let minRatioDiff = Infinity;

      // 遍历所有可能的行数，找到比例最贴合房间的组合
      for (let rows = 1; rows <= minCount; rows++) {
        const cols = Math.ceil(minCount / rows);
        const currentRatio = cols / rows;
        const diff = Math.abs(currentRatio - targetRatio);

        if (diff < minRatioDiff) {
          minRatioDiff = diff;
          bestRows = rows;
          bestCols = cols;
        }
      }

      return {
        rows: bestRows,
        cols: bestCols,
        total: bestRows * bestCols
      };
    }

    /**
     * 渲染布灯示意图：严格基于计算出的行列数生成灯点
     */
    function renderDiagram(rows, cols, spacingX, spacingY) {
      const grid = document.getElementById('diagramGrid');
      grid.innerHTML = '';
      
      // 设置网格行列
      grid.style.gridTemplateColumns = `repeat(${cols}, 1fr)`;
      grid.style.gridTemplateRows = `repeat(${rows}, 1fr)`;

      // 循环生成灯点，总数必然 = rows * cols
      for (let i = 0; i < rows * cols; i++) {
        const dot = document.createElement('div');
        dot.className = 'light-dot';
        grid.appendChild(dot);
      }

      // 更新间距标注
      document.getElementById('labelX').textContent = spacingX.toFixed(2);
      document.getElementById('labelY').textContent = spacingY.toFixed(2);
    }

    /**
     * 主计算函数
     */
    function calculateLighting() {
      // 1. 获取输入值
      const lengthFt = parseFloat(document.getElementById('roomLength').value);
      const widthFt = parseFloat(document.getElementById('roomWidth').value);
      const heightFt = parseFloat(document.getElementById('roomHeight').value);
      const selectedLight = LIGHT_TYPES.find(t => t.name === document.getElementById('lightType').value);
      const selectedUsage = USAGE_TYPES.find(t => t.name === document.getElementById('usageType').value);

      // 简单输入校验
      if (!lengthFt || !widthFt || !heightFt || lengthFt <= 0 || widthFt <= 0) {
        alert('Please enter valid room dimensions');
        return;
      }

      // 2. 单位转换：英尺转米，计算面积
      const areaSqm = (lengthFt * 0.3048) * (widthFt * 0.3048);
      const targetLux = selectedUsage.targetLux;
      const fixtureLumens = selectedLight.lumens;

      // 3. 计算理论最小灯具数
      const minCount = calcMinFixtureCount(areaSqm, targetLux, fixtureLumens);

      // 4. 计算最优网格布局（核心：统一数量与布局）
      const grid = getOptimalGrid(minCount, lengthFt, widthFt);

      // 5. 计算均匀间距
      const spacingX = lengthFt / grid.cols;
      const spacingY = widthFt / grid.rows;

      // 6. 功率建议逻辑
      const actualTotalLumens = grid.total * fixtureLumens;
      const actualLux = (actualTotalLumens * UTILIZATION_FACTOR) / (areaSqm * MAINTENANCE_FACTOR);
      let powerSuggestText = '';
      
      if (actualLux < targetLux) {
        // 当前功率下布局照度不足，建议更大功率
        const neededLumenPerFixture = (targetLux * areaSqm * MAINTENANCE_FACTOR) / (UTILIZATION_FACTOR * grid.total);
        const neededPower = Math.ceil(neededLumenPerFixture / LUMEN_EFFICIENCY);
        powerSuggestText = `We Suggest Use ${neededPower}~${neededPower + 20}W`;
      } else {
        powerSuggestText = `Current ${selectedLight.power}W is sufficient`;
      }

      // 7. 统一更新所有结果展示（所有数据来自同一计算源）
      document.getElementById('totalFixtures').textContent = `Number of fixtures needed: ${grid.total}`;
      document.getElementById('layout').textContent = `Layout: ${grid.cols} x ${grid.rows}`;
      document.getElementById('spacing').textContent = `Spacing: ${spacingX.toFixed(1)} x ${spacingY.toFixed(1)} ft`;
      document.getElementById('suggestPower').textContent = powerSuggestText;

      // 8. 渲染示意图
      renderDiagram(grid.rows, grid.cols, spacingX, spacingY);
    }

    // 页面加载时初始化
    window.onload = function() {
      initSelects();
      calculateLighting(); // 初始化默认计算一次
    };
